import request from '@/utils/http';

const costName = {
// 获取预览连接
    getPreview (params) {
        return request({
            url: `/api-srm-web/contract/contractFile/preview`,
            method: 'post',
            data: params
        });
    },
    getContractFiles (params) {
        params.attachmentId = '';
        params.mipAccount = '1';
        return request({
            url: `/api-srm/public/fw/attachmentPreview`,
            method: 'post',
            data: params
        });
    },
    fileDownload (params) {
        return request({
            url: `/api-srm-web/contract/contractFile/download`,
            method: 'post',
            responseType: 'arraybuffer',
            data: params
        });
    },
    getVerificationCode (params) {
        return request({
            url: `/api-srm-web/supplier/getVerificationCode`,
            method: 'post',
            data: params
        });
    },
    // 根据经纬度查地址详情
    geDetailAddressByGis (data) {
        return request({
            url: `/api-srm-web/supplier/geDetailAddressByGis`,
            method: 'get',
            params: data
        });
    },
    // 脱敏数据查看记录
    operationRecord (data) {
        return request({
            url: `/api-srm-web/supplier/supplierOperationRecord`,
            method: 'post',
            data
        });
    }
};
export default costName;
